<!-- Search + Type Filters Row -->
<div class="row d-flex align-items-center py-1 list-search-container-zone">
    <div class="col-12">
        <div class="list-search-container pe-1">
            <i class="fas fa-search list-search-icon"></i>
            <input type="text"
                (click)="$event.stopPropagation()"
                (input)="searchTextChanged($event.target.value)"
                [(ngModel)]="searchValue"
                placeholder="{{ 'Search bots' | translate }}"
                class="form-control list-search-input flex-grow-1">
            <i *ngIf="searchValue"
                (click)="resetListSearch()"
                class="fas fa-times btn-xs btn-bordered btn-danger btn-icon float-right nglist-item-action remove__icon mr-2"
                aria-hidden="true"></i>
            <button class="btn btn-sm btn-primary"
                (click)="openAddModal();$event.stopPropagation();"
                aria-hidden="true">{{'New bot' | translate}}</button>
        </div>
    </div>
    <div class="col-12 mt-2 mb-1">
        <div class="btn-group-primary-light btn-group-toggles btn-group-toggles-small d-inline-flex">
            <button *ngFor="let option of availableBotTypes"
                (click)="filterBotType(option.id)"
                class="btn-group-toggle {{option.id === currentBotType ? 'active' : ''}}">
                <i class="far fa-{{option.icon}} mr-1"></i>{{ option.name | translate }}
            </button>
        </div>
    </div>
</div>

<div class="list-search-options-zone">
    <!-- Loading State -->
    <div *ngIf="!isReady" class="d-flex justify-content-center my-5">
        <i class="fad fa-spinner-third fa-spin align-self-center fa-2x"></i>
    </div>

    <!-- Empty State -->
    <div *ngIf="isReady && filteredBots.length === 0" class="d-flex justify-content-center my-5 text-muted">
        <span>{{ 'No bots found' | translate }}</span>
    </div>

    <!-- Bot List -->
    <div *ngIf="isReady && filteredBots.length > 0" class="expanded-list row px-3 pb-0">
        <div class="col px-4 list-item-container">
            <div *ngFor="let bot of filteredBots; let i = index" class="item py-2 row" [class.selected]="isBotSelected(bot)">
                <!-- Icon + Name -->
                <div class="col-8 col-lg-9 d-flex align-items-center cursor-pointer" (click)="selectBot(bot)">
                    <span class="mr-2" style="display: inline-block; width: 16px;">
                        <!-- Loading state for data bots -->
                        <i *ngIf="bot.botType === 'data' && !muleServices.length"
                        class="fad fa-spinner-third fa-spin text-muted"
                        style="font-size: 0.75rem;"
                        tooltip="{{'Loading status...' | translate}}"
                        placement="right"></i>
                        <!-- Data bot status -->
                        <i *ngIf="bot.botType === 'data' && !bot.botServiceId && muleServices.length"
                        class="fad fa-circle-dot text-warning"
                        tooltip="{{'No service selected' | translate}}"
                        placement="right"></i>
                        <i *ngIf="bot.botType === 'data' && bot.botServiceId && bot.latestBotServiceId === false && muleServices.length"
                        class="fad fa-circle-dot text-danger"
                        tooltip="{{'Newer service available' | translate}}"
                        placement="right"></i>
                        <i *ngIf="bot.botType === 'data' && bot.latestBotServiceId === true && muleServices.length"
                        class="fad fa-circle-dot text-success"
                        tooltip="{{'Latest service' | translate}}"
                        placement="right"></i>
                        <!-- Internal bot status -->
                        <i *ngIf="bot.botType === 'internal' && !bot.inputFieldsMapping?.length"
                        class="fad fa-circle-dot text-warning"
                        tooltip="{{'Mapping is empty' | translate}}"
                        placement="right"></i>
                        <i *ngIf="bot.botType === 'internal' && bot.inputFieldsMapping?.length"
                        class="fad fa-circle-dot text-success"
                        tooltip="{{'Mapping started' | translate}}"
                        placement="right"></i>
                        <i *ngIf="bot.botType === 'message' && !(bot.selectedMessage && bot.selectedReceiver)"
                        class="fad fa-circle-dot text-warning"
                        tooltip="{{'Message Bot is not complete' | translate}}"
                        placement="right"></i>
                        <i *ngIf="bot.botType === 'message' && bot.selectedMessage && bot.selectedReceiver"
                        class="fad fa-circle-dot text-success"
                        tooltip="{{'Message Bot is ready' | translate}}"
                        placement="right"></i>
                    </span>
                    <i class="far fa-{{getBotIcon(bot)}} mr-2"></i>
                    <span>{{bot.name}}</span>
                </div>
                <!-- Actions -->
                <div class="col-4 col-lg-3 text-right" *ngIf="bot.botType !== 'system'">
                    <i class="fas fa-pencil btn-xs btn-bordered btn-light btn-icon item-remove mr-2"
                        (click)="openEditModal(bot);$event.stopPropagation();"></i>
                    <confirmation-popover
                        className="fas fa-times btn-xs btn-bordered btn-danger btn-icon float-right nglist-item-action"
                        (onConfirmed)="confirmDeleteBot(bot)"></confirmation-popover>
                </div>
            </div>
        </div>
    </div>
</div>
